export function usableHostFirstName (host) {
  const name = host && host.first_name;
  return typeof name === 'string' ? name.trim() : '';
}
